import OpenNewTab from "@material-ui/icons/LaunchRounded";
import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import React from "react";

interface RemittanceRunnerTblColDataTextProp {
  dataTitle: string;
  dataValue: string;
  isClickable?: boolean;
  isOrderInfo?: boolean;
  isUserCanManageRemittance?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const RemittanceRunnerTblColDataText: React.FC<RemittanceRunnerTblColDataTextProp> = props => {
  const { dataTitle, dataValue, isClickable, isOrderInfo, onClick } = props;
  const tblClasses = useTableStyles(props);

  const getClassNameStyle = () => {
    if (isOrderInfo) {
      return isClickable
        ? tblClasses.remittanceDataValue
        : tblClasses.remittanceDataValueDefault;
    }
    return isClickable && tblClasses.cursorHand;
  };

  const getContainerClassName = () => {
    if (isOrderInfo && dataValue) {
      return !isClickable
        ? tblClasses.remittanceDataValueDefault
        : tblClasses.remittanceDataDisplay;
    } else {
      return tblClasses.dataDisplay;
    }
  };

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>{dataTitle}</div>
      <div
        className={getContainerClassName()}
        onClick={isClickable ? onClick : null}
      >
        {maybe(() => dataValue) ? (
          <>
            <span className={getClassNameStyle()}>
              {dataValue}
              {isClickable && isOrderInfo && <OpenNewTab fontSize="small" />}
            </span>
          </>
        ) : (
          <>
            <span>{isOrderInfo ? "--" : "-----"}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColDataText;
